import { format, type Locale, parse } from "date-fns";
import { cs } from "date-fns/locale/cs";
import { enUS } from "date-fns/locale/en-US";
import { parseTimelineDate } from "web_myplann/NotificationCenter/Utils/parseTimelineDate";
import { DEFAULT_DATE_FORMAT } from "web_myplann/Shared/Utils/dateFormatters";

export const formatTimelineDate = (isoDate: string): string =>
	format(parseTimelineDate(isoDate), DEFAULT_DATE_FORMAT, { locale: cs });

const TIME_FORMATS: ReadonlyArray<{ format: string; locale: Locale }> = [
	{ format: "HH:mm:ss", locale: cs },
	{ format: "HH:mm", locale: cs },
	{ format: "h:mm:ss a", locale: enUS },
	{ format: "h:mm a", locale: enUS },
];

// Fixed non-DST reference date: date-fns `parse` writes H/M onto the
// reference's Y/M/D, and a same-day reference can flip across DST.
const TIME_PARSE_REFERENCE = new Date(2000, 0, 1);

const parseTimeOfDay = (time: string): Date | null => {
	const trimmed = time.trim();
	for (const { format: fmt, locale } of TIME_FORMATS) {
		const parsed = parse(trimmed, fmt, TIME_PARSE_REFERENCE, { locale });
		if (!Number.isNaN(parsed.getTime())) {
			return parsed;
		}
	}
	return null;
};

export const formatTimelineTime = (time: string): string => {
	const parsed = parseTimeOfDay(time);
	return parsed ? format(parsed, "HH:mm") : time.trim();
};
